import React, { Component } from "react";

export const GetConfigDaten = async (art = 0) => {
  //static displayName = Config.name;
  const configFilename = process.env.PUBLIC_URL + "/configurations.json";
  let data;
  try {
    const response = await fetch(configFilename);
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    data = await response.json();
    console.log("**** Art="+art+"   " + configFilename + " datenEinlesen geladen", data);
  } catch (error) {
    console.error("Fehler beim Laden von " + configFilename + " :", error);
  }
  switch (art) {
    case 1:
      return data.apiLogin[data.apiNr];
    case 2:
      return data.apiLogout[data.apiNr]; // logout eher nicht nötig !?
    default:
      return data.apiUrl[data.apiNr];
  }
};
